import { get, post, put, patch } from '../HttpService';


export class MerchantService {
    static get_key = (queryData = {}, config = {}) => {
        return get(`v1/internal/authentications/merchant/key/`, queryData, config);
    }

    static fetch = (queryData = {}, config = {}) => {
        return get(`v1/internal/authentications/merchant/info/`, queryData, config);
    }

    static updateConsent = (queryData = {}, config = {}) => {
        return patch(`v1/internal/merchants/settings`, queryData, config);
    }

    static generate_otp = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/generate_otp/`, queryData, config);
    }

    static generate_bank_otp = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/generate_bank_otp/`, queryData, config);
            }

    static verify_otp = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/verify_otp/`, queryData, config);
    }

    static logout = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/logout/`, queryData, config);
    }

    static generate_urn = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/generate_urn/`, queryData, config);
    }

    static generate_ulc = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/generate_ulc/`, queryData, config);
    }

    static login = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/login/`, queryData, config);
    }

    static save_settings = (queryData = {}, config = {}) => {
        let formData = new FormData();
        formData.append("theme", queryData.theme && queryData.theme.hex ? queryData.theme.hex : queryData.theme ? queryData.theme : null);
        formData.append("logo_file", queryData.file && queryData.file.file ? queryData.file.file : null);
        formData.append("key", queryData.key)
        return post(`v1/internal/authentications/settings/white_label/`, formData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    static save_notification_settings = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/settings/notifications/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    static save_bulk_upload_settings = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/settings/bulk_upload_settings/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    static get_public_info = (queryData = {}, config = {}) => {
        return get(`v1/internal/authentications/login/`, queryData, config);
    };

    static reset_password = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/password/`, queryData, config);
    };

    static get_payout_link_info = (queryData = {}, config = {}) => {
        return get(`v1/internal/authentications/payout_link/get_info/`, queryData, config);
    };

    static generate_payout_link_otp = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/payout_link/generate_otp/`, queryData, config);
    };

    static authenticate_payout_link = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/payout_link/authenticate/`, queryData, config);
    };

    static initiate_payout_link_attempt = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/payout_link/initiate/`, queryData, config);
    };

    static generate_soft_lock_otp = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/soft_lock/generate_otp/`, queryData, config);
    }

    static disable_soft_lock = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/soft_lock/disable/`, queryData, config);
    }

    static activate_virtual_account = (queryData = {}, config = {}) => {
        return post(`v1/internal/virtual_accounts/${queryData.id}/activate/`, queryData, config);
    }

    static update_settings = (queryData = {}) => {
        return post(`v1/internal/virtual_accounts/${queryData.id}/settings/`, queryData);
    }

    static get_balance = (queryData = {}) => {
        return get(`v1/internal/virtual_accounts/balance/`, queryData);
    };

    static generate_tally_credentials = (queryData = {}, config = {}) => {
        return post(`v1/internal/tally_invoices/generate_creds/`, queryData, config);
    }

    static update_transfer_request_approval_config = (queryData = {}, config = {}) => {
        return post(`v1/internal/merchants/update_approval_config/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    static get_approval_info = (queryData = {}, config = {}) => {
        return get(`v1/internal/authentications/approval/get_info/`, queryData, config);
    };

    static verify_captcha = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/verify_captcha/`, queryData, config);
    }

    static approve_request = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/approval/update_status/`, queryData, config);
    }

    static reset_password_link = (queryData = {}, config = {}) => {
        return post(`v1/internal/authentications/merchant/update_password/`, queryData, config);
    }
}